import React, { useEffect, useState } from 'react';
import { XIcon } from 'lucide-react';
export const VerificationCodeModal = ({
  onClose,
  onVerify
}) => {
  const [verificationCode, setVerificationCode] = useState(['', '', '', '', '', '']);
  const [animationComplete, setAnimationComplete] = useState(false);
  const codeToAnimate = ['0', '1', '2', '0', '3', '6'];
  useEffect(() => {
    let currentIndex = 0;
    const animateCodeEntry = () => {
      if (currentIndex < codeToAnimate.length) {
        setVerificationCode(prev => {
          const newCode = [...prev];
          newCode[currentIndex] = codeToAnimate[currentIndex];
          return newCode;
        });
        currentIndex++;
        setTimeout(animateCodeEntry, 300); // Animate each digit with a delay
      } else {
        setAnimationComplete(true);
        // Auto-submit after animation completes
        setTimeout(() => {
          onVerify();
        }, 1000);
      }
    };
    // Start animation after a short delay
    setTimeout(animateCodeEntry, 800);
  }, []);
  return <div className="fixed inset-0 bg-black bg-opacity-50 flex items-end justify-center z-50" data-id="element-504">
      <div className="bg-white rounded-t-xl w-full p-6 animate-slide-up" data-id="element-505">
        <div className="flex justify-end mb-4" data-id="element-506">
          <button onClick={onClose} data-id="element-507">
            <XIcon size={20} data-id="element-508" />
          </button>
        </div>
        <h2 className="text-xl font-bold mb-2" data-id="element-509">Verify your phone number</h2>
        <p className="text-gray-700 mb-6" data-id="element-510">
          We texted you a one-time verification code. Enter the code below.
        </p>
        <div className="flex justify-between mb-6" data-id="element-511">
          {verificationCode.map((digit, index) => <div key={index} className="w-12 h-12 bg-gray-100 rounded-lg flex items-center justify-center text-[#5c5cf5] text-xl font-bold" data-id="element-512">
              {digit}
            </div>)}
        </div>
        <button className="text-[#5c5cf5] font-medium mb-6" data-id="element-513">Resend Code</button>
        <button className={`w-full py-3 rounded-full font-medium ${animationComplete ? 'bg-[#5c5cf5] text-white' : 'bg-gray-200 text-gray-500'}`} disabled={!animationComplete} onClick={onVerify} data-id="element-514">
          Verify Phone Number
        </button>
      </div>
    </div>;
};